import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import api from "@/lib/api";
import ProductCard from "@/components/storefront/ProductCard";

const SavedPage = () => {
  const { saved } = useStore();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!saved.length) { setProducts([]); return; }
    Promise.all(saved.map((s) => api.get(`/products/${s}`).then((r) => r.data.product).catch(() => null)))
      .then((r) => setProducts(r.filter(Boolean)));
  }, [saved]);

  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-16 md:pt-24 min-h-[60vh]">
      <p className="overline text-gold mb-4">Saved Pieces</p>
      <h1 className="font-serif text-5xl md:text-7xl leading-none mb-14">Your saved pieces.</h1>
      {products.length === 0 ? (
        <div className="text-center py-24">
          <p className="font-serif text-4xl mb-4">Nothing saved. Yet.</p>
          <Link to="/collections/drop-001" className="inline-block mt-4 border border-espresso px-8 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover:bg-espresso hover:text-cream transition-colors">Discover DROP 001</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default SavedPage;
